<template>
  <ElDialog
    append-to-body
    title="Send to ThreeFlow Assist"
    :visible="visible"
    data-test="threeflow assist modal"
    top="70px"
    width="500px"
    @close="closeDialog"
  >
    <div v-if="diveUnsupportedProductTypes.length > 0">
      <h4 data-test="modal header">
        The following products are not eligible for an AI populated quote:
      </h4>
      <ul
        class="product-list"
        data-test="unsupported product types list"
      >
        <li
          v-for="(product, idx) in diveUnsupportedProductTypes"
          :key="`${product}-${idx}`"
        >
          {{ product }}
        </li>
      </ul>
    </div>
    <p>
      ThreeFlow Assist will review your proposal, enter your quotes, and send for your review within
      two business days. You can also enter the quote manually.
    </p>
    <div class="btn-group">
      <AppButton
        class="enter-rates-button"
        data-test="enter alternate manually"
        size="text"
        text="Enter Manually"
        type="secondary"
        @click="closeDialog"
      />
      <AppButton
        data-test="send to threeflow assist"
        size="large"
        text="Send to ThreeFlow Assist"
        type="primary"
        @click="sendToThreeFlowAssist"
      />
    </div>
  </ElDialog>
</template>

<script>
  import { mapActions, mapState } from 'pinia';
  import { sendPlanAltsToThreeFlowAssist } from '@/services/documents.js';
  import { useProductStore } from '@/stores/product.js';
  import { formatArrayIntoListOfStrings } from '@/utils/general.js';

  /**
   * Allow user to choose to either send plan Alts to ThreeFlow Assist or manually enter rates for alternates
   *
   * @exports Modals/StartOrUpdateRenewalModal/ThreeFlowAssist
   */
  export default {
    name: 'ThreeFlowAssist',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      proposalDocumentId: {
        type: Number,
        required: true,
      },
    },
    computed: {
      ...mapState(useProductStore, [
        'diveUnsupportedProductTypes',
        'threeflowAssistSupported',
      ]),
    },
    methods: {
      ...mapActions(useProductStore, ['setProducts']),
      closeDialog() {
        this.$emit('update:visible', false);
      },
      async sendToThreeFlowAssist() {
        this.$emit('showProductTableInfoMessage', `${formatArrayIntoListOfStrings(this.diveUnsupportedProductTypes)} supported by ThreeFlow Assist. ThreeFlow will enter your quote within two business days and send it to you to review and submit.`);

        try {
          const { document: { products } } = await sendPlanAltsToThreeFlowAssist(this.proposalDocumentId);

          this.setProducts(products);
        } catch (error) {
          this.$message({
            message: error.response?.data?.message || 'There was an error sending your alternates to ThreeFlow Assist. Please try again.',
            type: 'error',
          });
        } finally {
          this.closeDialog();
        }
      },
    },
  };
</script>
